// exporting all icons (border = 1.5, size = 25)
import { ReactComponent as defaultIcon } from "../assets/icons/danger.svg";
import { ReactComponent as infoIcon } from "../assets/icons/info.svg";
import { ReactComponent as audiovisIcon } from "../assets/icons/sounds.svg";
import { ReactComponent as autoexIcon } from "../assets/icons/forward.svg";
import { ReactComponent as denialIcon } from "../assets/icons/no-entry.svg";
import { ReactComponent as externalIcon } from "../assets/icons/exit.svg";
import { ReactComponent as filemodIcon } from "../assets/icons/folder-warning.svg";
import { ReactComponent as filesystemIcon } from "../assets/icons/folder.svg";
import { ReactComponent as internetIcon } from "../assets/icons/wifi.svg";
import { ReactComponent as lowlevelIcon } from "../assets/icons/battery-low.svg";
import { ReactComponent as memoryIcon } from "../assets/icons/save.svg";
import { ReactComponent as mutexIcon } from "../assets/icons/rotate.svg";
import { ReactComponent as networkIcon } from "../assets/icons/line-chart.svg";
import { ReactComponent as otherIcon } from "../assets/icons/box-alt.svg";
import { ReactComponent as privilegeIcon } from "../assets/icons/key.svg";
import { ReactComponent as registryIcon } from "../assets/icons/new.svg";
import { ReactComponent as resourcesIcon } from "../assets/icons/tool.svg";
import { ReactComponent as suspicousIcon } from "../assets/icons/envelope.svg";
import { ReactComponent as systemIcon } from "../assets/icons/chart.svg";
import { ReactComponent as virtualIcon } from "../assets/icons/cloud-upload.svg";
import { ReactComponent as browserIcon } from "../assets/icons/browser.svg";
import { ReactComponent as cryptoIcon } from "../assets/icons/lock-alt-open.svg";
import { ReactComponent as injectIcon } from "../assets/icons/code-alt.svg";
import { ReactComponent as dataIcon } from "../assets/icons/inbox-alt.svg";
import { ReactComponent as debugIcon } from "../assets/icons/bug.svg";
import { ReactComponent as detectIcon } from "../assets/icons/radio.svg";
import { ReactComponent as downloadIcon } from "../assets/icons/download.svg";
import { ReactComponent as enumIcon } from "../assets/icons/controls.svg";
import { ReactComponent as envIcon } from "../assets/icons/window.svg";
import { ReactComponent as evasionIcon } from "../assets/icons/eye-crossed.svg";
import { ReactComponent as executeIcon } from "../assets/icons/settings.svg";
import { ReactComponent as phoneIcon } from "../assets/icons/phone.svg";
import { ReactComponent as interceptIcon } from "../assets/icons/origin.svg";

const iconMapper = {
  Browser: {
    component: browserIcon,
  },
  Crypto: {
    component: cryptoIcon,
  },
  Debug: {
    component: debugIcon,
  },
  Download: {
    component: downloadIcon,
  },
  Evasion: {
    component: evasionIcon,
  },
  Virtual: {
    component: virtualIcon,
  },
  LowLevel: {
    component: lowlevelIcon,
  },
  Audiovisual: {
    component: audiovisIcon,
  },
  Memory: {
    component: memoryIcon,
  },
  Internet: {
    component: internetIcon,
  },
  Execute: {
    component: executeIcon,
  },
  Inject: {
    component: injectIcon,
  },
  Phone: {
    component: phoneIcon,
  },
  Detected: {
    component: detectIcon,
  },
  Registry: {
    component: registryIcon,
  },
  Denial: {
    component: denialIcon,
  },
  Enumerate: {
    component: enumIcon,
  },
  Info: {
    component: infoIcon,
  },
  Other: {
    component: otherIcon,
  },
  Filesystem: {
    component: filesystemIcon,
  },
  Filemod: {
    component: filemodIcon,
  },
  Data: {
    component: dataIcon,
  },
  System: {
    component: systemIcon,
  },
  Network: {
    component: networkIcon,
  },
  Suspicious: {
    component: suspicousIcon,
  },
  Privilege: {
    component: privilegeIcon,
  },
  Intercept: {
    component: interceptIcon,
  },
  Resources: {
    component: resourcesIcon,
  },
  External: {
    component: externalIcon,
  },
  Install: {
    component: defaultIcon,
  },
  Mutex: {
    component: mutexIcon,
  },
  Autoex: {
    component: autoexIcon,
  },
  Environment: {
    component: envIcon,
  },
};

export default iconMapper;
